(function (angular) {
    'use strict';

    angular
        .module('app.grievance', []);
        
})(angular);
